<template>
  <v-container class="limited">
    <v-layout column>
      <dados-beneficiario></dados-beneficiario>
      <gera-pinss></gera-pinss>
    </v-layout>
  </v-container>
</template>

<script>
import DadosBeneficiario from "@/components/BeneficiaryData";
import GeraPinss from "./gera-pinss";

export default {
  name: "Pinss",
  components: {
    DadosBeneficiario,
    GeraPinss
  }
};
</script>
